import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import Link from 'react-router/lib/Link';
import types from '../../../common/model-api/types';
import EditorSaver from '../../fw/EditorSaver';
import urlMapping from '../../app/URLMapping';
import {FullScreenPanel} from '../EmbededPanel.react';
import {FormattedMessage, IntlShape} from 'react-intl';
import {displayError} from '../../app/errorDisplayer';
import LoadingButton from '../../fw/LoadingButton.react';
import {wrapNotFound} from '../../app/NotFoundHandler.react';
import {sendToExtension} from '../../app/ExtensionCommunicate';
import config from '../../../common/config';
import CreateScreenFromTemplateMutation from './CreateScreenFromTemplateMutation.react';
import {sendReloadPanelForDetachedSettings, isOutlookPanel, isScreenSettingsOnlyIframe, screenSettingsOnlyClose, registerScreenId} from '../../../outlook/dialog';
import ScenarioBox from '../../scenarios/ScenarioBox.react';
import ScenarioStrip from '../../scenarios/ScenarioStrip.react';
import {sendMessage} from '../EmbededPanelController';
import mutationError from '../../channel-defs/mutationError';
import * as BrowserPermission from "../../BrowserPermission";
import {getLastOrganisationId} from '../../app/LastOrganisationId';

class CreateScreenStep2 extends React.Component {

    static propTypes = {
		params: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
    }

	componentDidMount() {
		sendReloadPanelForDetachedSettings(this.props.user.iotTopic);
	}

    static contextTypes = {
        embededPanelController: PropTypes.object,
        router: PropTypes.object,
        screenInfo: PropTypes.object,
        screenOperation: PropTypes.string,
    };

    createScreen = () => {
        return this._createFromTemplate({
            content: JSON.stringify({
                layout: 'list',
                views: [],
                children: []
            }),
        }, true);
    };

    _createFromTemplate = (template, wasEmpty) => {
        let fatQuery = Relay.QL `fragment on CreateScreenPayload @relay(pattern: true) {
                                    edge {
                                        node {
                                            id,
                                            realId,
                                        }
                                    },
                                }`;

        let mutation = Relay.QL `mutation { createScreen }`;
		let params = this.props.params;
        let save = types['screens'].defaultValues({
            operation: 'view',
            organisation_id: params.organisationId,
            channel_id: params.channelId,
            channelDef_id: this.props.user.organisation.channel.channelDef.id,
            channelEntityDef_id: params.channelEntityDefId,
        });

        let saver = new EditorSaver(types['screens'], mutation, fatQuery, null, EditorSaver.CREATE);
        return saver.save(save).then((saved) => {
			return this.onScreenCreated(saved.createScreen.edge.node.realId, wasEmpty);
        }).catch((e) => {
            displayError(e);
        });
    };

	onScreenCreated(savedScreenId, isEmpty) {
		sendMessage({
			msg: 'dativeryCreateScreen',
			screenId: savedScreenId
		});
		sendToExtension({
            msg: 'dativery-reload'
        });

		registerScreenId(savedScreenId);

		if (this.context.embededPanelController) {
			return this.context.embededPanelController.screenCreated(savedScreenId, isEmpty ? true : false);
		}

		if (isOutlookPanel() || isScreenSettingsOnlyIframe()) {
			if (isEmpty) {
				let params = this.props.params;
				let screenInfo = {
					organisation_id: params.organisationId,
					channel_id: params.channelId,
					screen_id: savedScreenId
				};
				let path = urlMapping.getUrl('panel', "screen-settings", screenInfo);
				this.context.router.push(path + location.search);
			} else {
				window.close();
			}
		}
	}

	createScreenFromTemplate(screenDef, usedScenarioWithScreen) {
		let params = this.props.params;
		let args = {
			operation: 'view',
			organisation_id: params.organisationId,
			channel_id: params.channelId,
			channelDef_id: this.props.user.organisation.channel.channelDef.realId,
			channelEntityDef_id: params.channelEntityDefId,
		};

		if (screenDef) {
			args['screenDef'] = screenDef;
		}
		if (usedScenarioWithScreen) {
			args['scenarioScreenDef'] = usedScenarioWithScreen.screenDef;
			args['usedScenario'] = usedScenarioWithScreen.usedScenario;
		}

		return new Promise((resolve, reject) => {
			let onFailure = (transaction) => {
				mutationError(transaction);
				reject();
			};

			let onSuccess = (response) => {
				resolve();
				return this.onScreenCreated(response.createScreenFromTemplate.updatedNode.realId, false);
			};

			// To perform a mutation, pass an instance of one to `Relay.Store.commitUpdate`
			Relay.Store.commitUpdate(new CreateScreenFromTemplateMutation(args), {
				onFailure,
				onSuccess
			});
		});
	}

    close = () => {
		if (isOutlookPanel()) {
			window.close();
			return;
		}
		if (isScreenSettingsOnlyIframe()) {
			screenSettingsOnlyClose();
			return;
		}

        let path = urlMapping.getUrl("panel", "no-screen", this.context.embededPanelController.getURLObject());
        this.context.router.push(path);
    };


    reloadExtension = () => {
        return this.context.embededPanelController.reloadDativery().then(() => {
            this.close();
        });
    };

    onUsedScenarioClick = (event, scenario) => {
        let path = urlMapping.getUrl("panel", "no-screen", this.context.embededPanelController.getURLObject());
        this.context.router.push(path);

        return false;
    };

	renderScreenDef(screenDef, idx, onClickAction) {
		if (!screenDef.name) {
			return null;
		}
        let channel = this.props.user.organisation.channel;

        let type = types['screens'];

		return (
			<div className="dativery-screen-def-box" key={idx}>
				<h3>{screenDef.name}</h3>
				{screenDef.description ? <p>{screenDef.description}</p> : <p><i><FormattedMessage defaultMessage="no description" id="screen.create-2.screen.noDescription" /></i></p>}
                {type.canCreate(BrowserPermission.getPermissionObject(), channel, this.props.user.organisation.realId) && type.canUserCreate(channel) ?
                    <LoadingButton className="btn btn-primary" onClick={() => { return onClickAction(); }}><FormattedMessage defaultMessage="Create screen" id="screen.create-2.useTemplate" /></LoadingButton>
                    :
                    <LoadingButton className="btn btn-primary" disabled><FormattedMessage defaultMessage="You are not allowed to create screen" id="screen.create.noPermission" /></LoadingButton>
                }

			</div>
		);
	}

    render() {
		let self = this;
        let findSame = this.props.user.organisation.channel.screens.edges.findIndex(({node}) => {
           if (self.context.screenInfo && node['operation'] === self.context.screenInfo['operation']) {
               return true;
           }

           return false;
        });

        if (findSame !== -1) {
            /* somebody created screen and there is already one in background */

            sendToExtension({
                message: 'dativery-reload'
            });
        }

        let type = types['screens'];
        let channel = this.props.user.organisation.channel;
        let allScreenDefs = this.props.user.organisation.channel.channelDef.channelEntityDef.entityDef.allScreenDefs.edges.map(({node}) => node);
        let allScenarioScreenDefs = this.props.user.organisation.channel.usedScenarioScreenDefsToUse.edges.map(({node}) => node);

        return (
            <FullScreenPanel close={this.close} showBackToPanel typeForTest="CreateScreenStep2">
                <div className="bordered-content autoscrollbar">
                    <h2><FormattedMessage defaultMessage="Screen Settings - create" id="screen.create-step-2.title" /></h2>

                    {findSame === -1 ?
                        <div>
                            <p><FormattedMessage defaultMessage="Screen shows you all the important information you want to see. Let's create your first screen." id="screen.create-2.description" /></p>

                            <div className="dativery-screen-def-container">

                                {allScreenDefs.map((screenDef, idx) => {
									return this.renderScreenDef(screenDef, idx, () => {
										return this.createScreenFromTemplate(screenDef);
									});
                                })}

                                {allScenarioScreenDefs.map((usedScenarioWithScreen, idx) => {
                                    let screenDef = usedScenarioWithScreen.screenDef;

									return this.renderScreenDef(screenDef, idx, () => {
										return this.createScreenFromTemplate(null, usedScenarioWithScreen);
									});
                                })}

                                <div className="dativery-screen-def-box">
                                    <h3><FormattedMessage defaultMessage="Blank screen" id="screen.create-2.emptyScreen.title2" /></h3>
                                    <p><FormattedMessage defaultMessage="Start with clean desk and customize your own screen." id="screen.create-2.emptyScreen.description" /></p>
                                    {type.canCreate(BrowserPermission.getPermissionObject(), channel, this.props.user.organisation.realId) && type.canUserCreate(channel) ?
                                        <LoadingButton className="btn btn-success" onClick={this.createScreen}><FormattedMessage defaultMessage="Create screen" id="screen.create-2.emptyScreen.button2" /></LoadingButton>
                                        :
                                        <LoadingButton className="btn btn-success" disabled><FormattedMessage defaultMessage="You are not allowed to create screen" id="screen.create.noPermission" /></LoadingButton>
                                    }

                                </div>
                            </div>

							<ScenarioStrip
                                absoluteUrls
                                onClick={this.onUsedScenarioClick}
								scenarios={this.props.user.organisation.channel.relevantScenarios}
								title={(<FormattedMessage defaultMessage="Interesting scenarios:" id="channelList.scenarios" />)}
								viewMore={(
									<Link className="right btn btn-default btn-lg" target="_blank" to={config.PUBLIC_APP_URL + urlMapping.getUrl(types['scenarios'], "list-all")}><FormattedMessage defaultMessage="Show more scenarios" id="channelList.scenarios.seeMore" />{" "}<i className="fa fa-chevron-circle-right"></i></Link>
								)}
							/>
                        </div>
                    :
                        <div className="embedLoading">
                            <div>
                                <p><FormattedMessage defaultMessage="Screen has been already created in other window." id="screen.create-2.reloadScreen.description" /></p>
                                <LoadingButton className="btn btn-default" onClick={this.reloadExtension} style={{padding: '1em'}}><span className="fa fa-refresh"/> <FormattedMessage defaultMessage="Reload {product}" id="screen.create-2.reloadScreen.button" values={{product: config.PRODUCT_NAME}}/></LoadingButton>
                            </div>
                        </div>
                    }

                </div>
            </FullScreenPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(CreateScreenStep2, (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.channelDef && props.user.organisation.channel.channelDef.channelEntityDef;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        channelEntityDefId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
					iotTopic,
                    organisation(id: $organisationId) {
                        id,
                        realId,
                        channel(id: $channelId) {
                            id,
                            realId,
                            relevantScenarios(first: 4, channelEntityDefId: $channelEntityDefId) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        ${ScenarioBox.getFragment('scenario')}
                                    }
                                },
                                pageInfo {
                                    hasNextPage,
                                    hasPreviousPage,
                                    startCursor,
                                    endCursor
                                }
                            }
                            screens(first: 10, channelEntityDef: $channelEntityDefId) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        operation,
                                        subOperation,
                                    }
                                }
                            },
                            usedScenarioScreenDefsToUse(first: 200, channelEntityDef: $channelEntityDefId) {
                                edges {
                                    node {
                                        screenDef {
                                            id,
                                            realId,
                                            scenarioDef_id,
                                            name,
                                            description,
                                        },
                                        usedScenario {
                                            id,
                                            realId,
                                            scenario_id,
                                        }
                                    }
                                }
                            },
                            channelDef {
                                id,
                                realId,
                                name,
                                icon,
                                channelEntityDef(id: $channelEntityDefId) {
                                    id,
                                    realId,
                                    entityDef {
                                        id,
                                        realId,
                                        name,
                                        allScreenDefs(first: 200) {
                                            edges {
                                                node {
                                                    id,
                                                    realId,
                                                    operation,
                                                    name,
                                                    description,
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`;
        }
    },
});
